import { render, staticRenderFns } from "./EventMobileCard.vue?vue&type=template&id=881beddc&scoped=true&"
import script from "./EventMobileCard.vue?vue&type=script&lang=js&"
export * from "./EventMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881beddc",
  null
  
)

export default component.exports